export default __webpack_public_path__ + "static/media/CuciStep4.1142e71d.png";